import { bridge } from '../../bridge';

/**
 * - 검색 페이지로 이동
 */
export const moveToSearch = () => {
  bridge.openPath('/search');
};
